import styled, { keyframes, css } from 'styled-components';
import { FlexCenterAligned } from './common';
import { Breakpoints } from './constants';

export const placeload = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

export const animation = css`
  animation: ${placeload} 1s forwards infinite linear;
  background: ${({ theme: { colors } }) =>
    `linear-gradient(to right, ${colors.background.secondary} 8%, ${colors.border.primary} 18%, ${colors.background.secondary} 33%)`};
  background-size: 1200px 104px;
`;

export const PlaceholderBlock = styled.div<{
  width?: string;
  height?: string;
  margin?: string;
  borderRadius?: string;
}>`
  width: ${({ width = '100%' }) => width};
  height: ${({ height = '18px' }) => height};
  margin: ${({ margin = '10px 0' }) => margin};
  border-radius: ${({ borderRadius = '7px' }) => borderRadius};
  ${animation};
`;

export const ItemCreationHeader = styled(FlexCenterAligned)<{
  $isClient?: boolean;
}>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  height: 60px;
  background-color: ${({ theme: { colors } }) => colors.background.primary};
  font-size: 16px;
  font-weight: 700;
  margin-top: ${({ $isClient }) => ($isClient ? 0 : 3)}px;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 71px;
    border-bottom: 0;
    font-size: 0;
    ${({ $isClient }) => $isClient && 'display: none;'}
  }
`;
